module.exports = __webpack_public_path__ + "img/paintballgun.0ab76dab.png";